// Información de build generada automáticamente
export const BUILD_DATE = '17-08-2026 19:18:08';
export const BUILD_HASH = '8xd5gw1ldxf';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1787005088696;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '17-08-2026 19:18:08',
  buildHash: '8xd5gw1ldxf',
  appVersion: '0.0.0',
  timestamp: 1787005088696
});
